import { render, staticRenderFns } from "./CompanyPractices.vue?vue&type=template&id=fb729c34&"
import script from "./CompanyPractices.vue?vue&type=script&lang=ts&"
export * from "./CompanyPractices.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyPractices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports